<template>
  <div class="qc-inspection-dialog">
    <div class="dialog-overlay" @click="closeDialog">
      <div class="dialog-content" @click.stop>
        <!-- Header -->
        <div class="dialog-header">
          <div class="header-left">
            <div class="header-icon">
              <img src="~@/assets/images/icons/checklistGray.svg" alt="Checklist" class="checklist-icon" />
            </div>
            <div class="header-text">
              <h2 class="dialog-title">Quality Check Inspection</h2>
              <!-- <p class="job-order">Job Order No.: {{ 'jobOrderNumber' }}</p> -->
            </div>
          </div>
          <button class="close-btn" @click="closeDialog">×</button>
        </div>

        <!-- Content -->
        <div class="dialog-body">
          <div class="content-container">
            <!-- Job Information -->
            <div class="job-information">
              <h3>Checklist Information</h3>
              <div class="info-grid">
                <qc-default-field  :label="'Part Name'" :value="formData.partName" />
                <qc-default-field  :label="'Part Number'" :value="formData.partNumber" />
                <qc-default-field  :label="'Operation'" :value="stepName" />
                <qc-default-field  :label="'Created By'" :value="formData.created_by" />
                <qc-default-field  :label="'Created On'" :value="formData.created_on | genericFormatDate" />
                <qc-default-field  :label="'Updated By'" :value="formData.updated_by" />
                <qc-default-field  :label="'Updated On'" :value="formData.updated_on| genericFormatDate" />
              </div>

              <div class="separator"></div>

              <div class="input-grid">
                <div class="input-item">
                  <label>Inspector Name</label>
                  <div
                    class="info-input v-center elipsis-text" v-overflow-tooltip
                  >{{formData.inspector?.name}}
                </div>
                </div>
                <div class="input-item">
                  <label>Status</label>
                  <div class="status-display">
                    <div class="status-icon">
                      <div :class="['status-circle', getStatusClass(inspectionStatus)]">
                        <span class="status-symbol">{{ getStatusIcon(inspectionStatus) }}</span>
                      </div>
                    </div>
                    <span class="status-text">{{ inspectionStatus.label }}</span>
                  </div>
                </div>
                <div class="input-item">
                  <label>Action</label>
                  <div class="status-buttons">
                    <button
                      :disabled="!edit"
                      v-for="status in statusOptions"
                      :key="status.value"
                      :class="['status-btn', status.color, { active: inspectionStatus.value === status.value,'no-hover':!edit && inspectionStatus.value !== status.value }]"
                      @click="inspectionStatus = status"
                    >
                      {{ status.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Inspection Checks -->
            <div v-for="(table, tableFieldId) in tableData" :key="tableFieldId" class="inspection-checks">
              <div class="section-header">
                <div class="section-title">
                  <h3>Checklist items</h3>
                  <span class="check-count">{{ Object.keys(table?.rows).length }} check points</span>
                </div>
                <!-- <button class="add-check-btn" @click="addCheckItem">
                  <span>+</span> Add Check
                </button> -->
              </div>

              <!-- Inspection Table -->
              <div class="inspection-table">
                <table>
                  <thead>
                    <tr class="table-header">
                      <th class="sr-col">Sr.</th>
                    <th v-for="headingIndex in (Object.keys(table?.column))" :key="headingIndex" class="param-col">{{table?.column[headingIndex]?.label}}
                      <span
                      v-if="table?.column[headingIndex]?.required"
                          class="column-required-asterisk"
                          v-tooltip="'Mandatory field'"
                        >*</span>
                    </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in Object.keys(table?.rows)" :key="'row'+rowIndex" class="table-row">
                      <td class="sr-cell">{{ rowIndex*1 + 1 }}</td>
                      <td class="param-cell" v-for="(item, cellIndex) in table?.rows?.[row]" :key="'cell'+ rowIndex+''+cellIndex">
                        <qc-table-cell :item="item" :columnFeatures="table.column[cellIndex]" :tableFieldId="tableFieldId" :columnIndex="+cellIndex" :rowIndex="+row"  @updateRowData="updateRowData" :edit="edit" />
                      </td></tr>
                  </tbody>
                </table>
              </div>

              <!-- Summary -->
              <div v-if="true" class="summary-section">
                <!-- <div class="summary-stats">
                  <div class="stat-item">
                    <span class="stat-label">Pass Rate:</span>
                    <span class="stat-value">-- %</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Passed:</span>
                    <span class="stat-value passed">--</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Failed:</span>
                    <span class="stat-value failed">--</span>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="dialog-footer">
          <button class="btn btn-cancel" @click="closeDialog">Cancel</button>
          <button class="btn btn-history" @click="showQCHistory">
            <span class="history-icon">📋</span>
            QC History
          </button>
          <button class="btn btn-save" v-if="edit" @click="saveInspection">
            <span class="save-icon">💾</span>
            Save Inspection
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EditForm, GetFormDataByFormId, getFormTemplateByVersionId } from '@/api'
import { genericFormatDate } from '@/utils/date'
import qcDefaultField from '@/components/form/elements/qcDefaultField.vue'
import qcTableCell from '@/components/form/elements/qcTableCell.vue'
import config from '@/config'
import Loader from '@/plugins/loader'
import { alert, success } from '@/plugins/notification'
import { mapGetters } from 'vuex'
export default {
  name: 'QCInspectionDialog',
  filters: {
    genericFormatDate
  },
  props: {
    qcTemplateId: {
      type: String,
      required: true
    },
    qcformId: {
      type: String,
      required: true
    },
    stepName: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    qcDefaultField, qcTableCell
  },
  data () {
    return {
      currentInspectorName: this.inspectorName,
      inspectionStatus: {},
      notes: '',
      tableData: {},
      config: config,
      formData: {},
      templateField: [],
      statusOptions: [
        { value: config.FORM_STATE_MAP.IN_PROGRESS, label: 'In Progress', color: 'orange' },
        { value: config.FORM_STATE_MAP.APPROVED, label: 'Approved', color: 'green' },
        { value: config.FORM_STATE_MAP.REJECTED, label: 'Rejected', color: 'red' },
        { value: config.FORM_STATE_MAP.HOLD, label: 'Hold', color: 'yellow' }
      ]
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    async setup () {
      const loader = new Loader()
      try {
        loader.show()
        const formRes = await GetFormDataByFormId(this.qcformId, false)
        const formValues = formRes.core_forms_by_pk
        const templateData = await getFormTemplateByVersionId(this.qcTemplateId, formValues.template_version_id)
        this.formTemplateData = templateData.core_form_templates_by_pk
        this.createTableBody(this.formTemplateData, formValues.forms_table)
        loader.hide()
        console.log(formValues.updated_by_user, 'updated user')
        this.formData = {
          id: formValues.id,
          status: formValues.status,
          created_on: formValues.created_on,
          created_by: formValues.created_by_user
            ? `${formValues.created_by_user.first_name} ${formValues.created_by_user.last_name}`
            : '--',
          updated_on: formValues.updated_on,
          updated_by: formValues.updated_by_user
            ? `${formValues.updated_by_user.first_name} ${formValues.updated_by_user.last_name}`
            : '--'
        }
        this.inspectionStatus = this.updateInspectionStatus(this.formData.status)
        for (const item of formValues.forms_metadata_by_id) {
          const value = item.time_value?.split('+')[0] ??
    item.int_value ??
    item.date_value ??
    item.bool_value ??
    item.point_value ??
    item.string_value ??
    '--'
          switch (item.field_id) {
          case config.DEFAULT_QC_FIELD_ID_MAPS.PART_NAME:
            this.formData.partName = value
            break
          case config.DEFAULT_QC_FIELD_ID_MAPS.PART_NUMBER:
            this.formData.partNumber = value
            break
            // case config.DEFAULT_QC_FIELD_ID_MAPS.operation:
            //   this.formData.operation = value
            //   break
          default:
            break
          }
        }
        for (const item of formValues.forms_user_lists) {
          if (item.field_id === config.DEFAULT_QC_FIELD_ID_MAPS.INSPECTOR) {
            this.formData.inspector = { name: item.core_user.first_name + ' ' + item.core_user.last_name, flag: 'existing' }
            break
          }
        }
        if (!this.formData.inspector) {
          this.formData.inspector = { name: this.user.first_name + ' ' + this.user.last_name, flag: 'new' }
        }
      } catch (err) {
        loader.hide()
        console.log(err)
        alert('Something went wrong')
      }
    },
    createTableBody (templateData, formTableData) {
      const tableData = {}
      const defaultData = []
      const fieldIdTableDataMap = {}
      for (const field of formTableData) {
        fieldIdTableDataMap[field.field_id] = field
      }
      let count = 0
      for (const item of templateData?.template_versions[0].template_fields) {
        if (item.field_type_id !== config.FORM_TYPE.TABLE) {
          if (item.autogenerated) continue // no need to track auto generated fields , its hard coded
          defaultData.push(item)
          continue
        } else {
          tableData[item.field_id] = { column: {}, rows: {} }
          // creating column data
          item.table_data.columns.forEach((column, index) => {
            tableData[item.field_id].column[index] = column
            count++
          })
        }
        // create  row data
        const tableRowData = fieldIdTableDataMap[item.field_id].table_data.rows
        tableRowData.forEach((row, index) => {
          tableData[item.field_id].rows[index] = new Array(count).fill('--')
          tableData[item.field_id].rows[index].forEach((cell, cellIndex) => {
            const columnData = tableData[item.field_id].column[cellIndex]
            tableData[item.field_id].rows[index][cellIndex] = row[columnData.id] ?? null
          })
        })
      }
      this.templateField = defaultData
      this.tableData = tableData
    },

    convertBackToOriginal (tableData) {
      const inputPayload = []
      const rowData = []
      for (const [fieldId, table] of Object.entries(tableData)) {
        const originalTable = {
          field_id: fieldId,
          value: []
        }
        const rowFieldIndex = {}
        for (const key in table.column) {
          rowFieldIndex[key] = table.column[key].id
        }
        for (const key in table.rows) {
          const obj = {}
          table.rows[key].forEach((cell, cellIndex) => {
            const field = rowFieldIndex[cellIndex]
            obj[field] = cell
          })
          rowData[key] = obj
        }
        originalTable.value = { rows: rowData }
        inputPayload.push(originalTable)
      }
      return inputPayload
    },
    closeDialog () {
      this.$emit('close')
    },
    showQCHistory () {
      // Emit event to parent component to show QC history
      this.$emit('showQCHistory', {
        qcformId: this.qcformId,
        qcTemplateId: this.qcTemplateId,
        stepName: this.stepName
      })
    },
    getStatusClass (status) {
      const statusClasses = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: 'in-progress',
        [config.FORM_STATE_MAP.APPROVED]: 'approved',
        [config.FORM_STATE_MAP.REJECTED]: 'rejected',
        [config.FORM_STATE_MAP.HOLD]: 'hold'
      }
      return statusClasses[status.value] || 'in-progress'
    },
    getStatusIcon (status) {
      const statusIcons = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: '✓',
        [config.FORM_STATE_MAP.APPROVED]: '✓',
        [config.FORM_STATE_MAP.REJECTED]: '✗',
        [config.FORM_STATE_MAP.HOLD]: '⏸'
      }
      return statusIcons[status.value] || '✓'
    },
    validateTableData (tableData) {
      // Loop through every table
      for (const [fieldId, table] of Object.entries(tableData)) {
        // Find all required columns dynamically
        const requiredColumns = Object.entries(table.column)
          .filter(([key, column]) => column.required === true)
          .map(([key, column]) => ({
            index: Number(key),
            id: column.id,
            label: column.label
          }))

        for (const [rowIndex, row] of Object.entries(table.rows)) {
          // Check every required column
          for (const column of requiredColumns) {
            const value = row[column.index]

            // Check if value is empty
            const isEmpty =
          value === null ||
          value === undefined ||
          value === '' ||
          (Array.isArray(value) && value.length === 0)

            if (isEmpty) {
              return {
                valid: false,
                fieldId: fieldId,
                rowIndex: Number(rowIndex),
                columnId: column.id,
                columnLabel: column.label
              }
            }
          }
        }
      }
      return {
        valid: true
      }
    },
    saveInspection () {
      const validation = this.validateTableData(this.tableData)

      if (!validation.valid) {
        alert(
      `${validation.columnLabel} is required please fill all rows.`
        )
        return
      }
      const loader = new Loader()
      loader.show()
      const inputPayload = this.convertBackToOriginal(this.tableData)
      if (this.formData.inspector?.flag === 'new') {
        inputPayload.push({
          field_id: config.DEFAULT_QC_FIELD_ID_MAPS.INSPECTOR,
          value: { insert: [{ user_id: this.user.userId, target_tenant_id: this.user.tenantId }] }
        })
      }
      const payload = {
        formId: this.formData?.id,
        metadataPayload: inputPayload,
        status: this.inspectionStatus.value
      }
      EditForm(payload).then(async (res) => {
        this.$emit('save')
        this.closeDialog()
        loader.hide()
        success('Checklist saved successfully')
      })
        .catch(() => {
          loader.hide()
          alert('Unable to update checklist ')
        })
    },
    updateRowData (data) {
      this.tableData[data.tableFieldId].rows[data.rowIndex][data.columnIndex] = data.value
    },
    updateInspectionStatus (statusId) {
      switch (statusId) {
      case config.FORM_STATE_MAP.IN_PROGRESS:
        return { value: config.FORM_STATE_MAP.IN_PROGRESS, label: 'In Progress' }
      case config.FORM_STATE_MAP.APPROVED:
        return { value: config.FORM_STATE_MAP.APPROVED, label: 'Approved' }
      case config.FORM_STATE_MAP.REJECTED:
        return { value: config.FORM_STATE_MAP.REJECTED, label: 'Rejected' }
      case config.FORM_STATE_MAP.HOLD:
        return { value: config.FORM_STATE_MAP.HOLD, label: 'Hold' }
      default:
        return { }
      }
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style lang="scss" scoped>
.qc-inspection-dialog {
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .dialog-content {
    background: white;
    border-radius: 8px;
    max-width: 1400px;
    width: 95%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    padding: 10px;
  }

  .dialog-header {
    padding: 24px;
    border-bottom: 1px solid #e5e7eb;
    background: white;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .header-icon {
        width: 40px;
        height: 40px;
        background-color:  var(--brand-color);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        .checklist-icon {
          width: 20px;
          height: 20px;
          filter: brightness(0) invert(1);
        }
      }

      .header-text {
        .dialog-title {
          font-size: var(--text-xl);
          font-weight: 600;
          color: #111827;
          margin: 0;
          line-height: 1.2;
          text-align: left;
        }

        .job-order {
          font-size: var(--text-base);
          color: #6b7280;
          margin: 0;
          line-height: 1.2;
          text-align: left;
        }
      }
    }

    .close-btn {
      background: none;
      border: none;
      font-size: var(--text-3xl);
      cursor: pointer;
      color: #6b7280;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;

      &:hover {
        background-color: #f3f4f6;
        color: #374151;
      }
    }
  }

  .dialog-body {
    flex: 1;
    overflow-y: auto;
    background-color: #f9fafb;
    padding: 24px;

    .content-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }

  .job-information {
    background: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    padding: 24px;

    h3 {
      font-size: var(--text-base);
      font-weight: 600;
      color: #000000;
      margin: 0 0 16px 0;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;
      margin-bottom: 16px;

      .info-item {
        label {
          display: block;
          font-size: var(--text-s);
          color: #6b7280;
          margin-bottom: 6px;
        }

        .info-value {
          font-size: var(--text-base);
          color: #111827;

          &.mono {
            font-family: monospace;
          }
        }
      }
    }

    .separator {
      height: 1px;
      background-color: #e5e7eb;
      margin: 16px 0;
    }

    .input-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;

      .input-item {
        label {
          display: block;
          font-size: var(--text-s);
          color: #6b7280;
          margin-bottom: 8px;
        }

        .info-input {
          width: 100%;
          max-width: 400px;
          height: 36px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          padding: 0 12px;
          font-size: var(--text-base);

          &:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 1px #3b82f6;
          }
        }

        .status-display {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 0;
          font-size: var(--text-base);
          background: none;
          color: #000000;
          font-weight: 500;
          height: auto;
          width: auto;

          .status-icon {
            .status-circle {
              width: 16px;
              height: 16px;
              border: 1px solid white;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;

              .status-symbol {
                color: white;
                font-size: var(--text-xs1);
                font-weight: bold;
                line-height: 1;
              }

              &.in-progress, progress {
                background-color: #ff7b00; // Green
              }

              &.approved {
                background-color: #16a34a; // Darker green
              }

              &.rejected {
                background-color: #dc2626; // Red
              }

              &.hold {
                background-color: #eab308; // Yellow
              }
            }
          }

          .status-text {
            color: #000000;
            font-size: var(--text-base);
            font-weight: 500;
          }
        }

        .status-buttons {
          display: flex;
          gap: 8px;

          .status-btn {
            padding: 6px 12px;
            border-radius: 4px;
            font-size: var(--text-s);
            border: none;
            cursor: pointer;
            transition: all 0.2s;
            background-color: #f3f4f6;
            color: #374151;

            &:hover {
              background-color: #e5e7eb;
            }

            &.active {
              background-color: #111827;
              color: white;
            }

            &.green {
              background-color: #dcfce7;
              color: #166534;
              border: 1px solid #bbf7d0;

              &:hover {
                background-color: #bbf7d0;
              }

              &.active {
                background-color: #16a34a;
                color: white;
                border-color: #16a34a;
              }
            }

            &.red {
              background-color: #fef2f2;
              color: #991b1b;
              border: 1px solid #fecaca;

              &:hover {
                background-color: #fecaca;
              }

              &.active {
                background-color: #dc2626;
                color: white;
                border-color: #dc2626;
              }
            }

            &.yellow {
              background-color: #fefce8;
              color: #a16207;
              border: 1px solid #fde047;

              &:hover {
                background-color: #fde047;
              }

              &.active {
                background-color: #eab308;
                color: white;
                border-color: #eab308;
              }
            }
            &.orange {
              background-color: #fefce8;
              color: #ff7b00;
              border:1px solid #edc7a3;

              &:hover {
                background-color: #ff7b0062;
              }

              &.active {
                background-color: #ff7b00;
                color: white;
                border-color:#ff7b00;
              }
            }
                &.no-hover {
      background-color: #e5e7eb !important;
      color: #9ca3af !important;
      border: 1px solid #d1d5db !important;
      cursor: not-allowed !important;

      &:hover {
        background-color: #e5e7eb !important;
      }
    }
          }
        }

      }
    }
  }

  .inspection-checks {
    background: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;

    .section-header {
      padding: 16px 24px;
      border-bottom: 1px solid #e5e7eb;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .section-title {
        h3 {
          font-size: var(--text-base);
          font-weight: 600;
          color: #000000;
          margin: 0;
        }

        .check-count {
          font-size: var(--text-s);
          color: #6b7280;
          margin-top: 2px;
          display: block;
        }
      }

      // .add-check-btn {
      //   display: flex;
      //   align-items: center;
      //   gap: 8px;
      //   padding: 6px 12px;
      //   border: 1px solid #d1d5db;
      //   border-radius: 4px;
      //   background: white;
      //   color: #374151;
      //   font-size: var(--text-s);
      //   cursor: pointer;
      //   transition: all 0.2s;

      //   &:hover {
      //     background-color: #f9fafb;
      //   }
      // }
    }

    .inspection-table {
      overflow-x: auto;

      table {
        width: 100%;
        border-collapse: collapse;

        .table-header {
          background-color: #f9fafb;

          th {
            padding: 12px;
            text-align: left;
            font-size: var(--text-s);
            font-weight: 600;
            color: #374151;
            border-bottom: 1px solid #e5e7eb;

            &.sr-col { width: 48px; text-align: center; }
            &.param-col { min-width: 200px; }
            &.spec-col { min-width: 180px; }
            &.value-col { width: 140px; }
            &.result-col { width: 140px; text-align: center; }
            &.remarks-col { min-width: 200px; }
            &.action-col { width: 48px; }
          }
        }

        .table-row {
          &:hover {
            background-color: #f9fafb;

            .delete-btn {
              opacity: 1;
            }
          }

          td {
            padding: 8px 12px;
            border-bottom: 1px solid #e5e7eb;

            &.sr-cell {
              text-align: center;
              font-size: var(--text-base);
              color: #6b7280;
            }

            .table-input {
              width: 100%;
              height: 36px;
              border: 1px solid #d1d5db;
              border-radius: 4px;
              padding: 0 12px;
              font-size: var(--text-base);
              background-color: #f3f4f6;
              color: #6b7280;

              &:focus {
                outline: none;
                border-color: #3b82f6;
                box-shadow: 0 0 0 1px #3b82f6;
                background-color: white;
                color: #374151;
              }
            }

            .result-buttons {
              display: flex;
              gap: 8px;

              .result-btn {
                flex: 1;
                padding: 8px 12px;
                border-radius: 4px;
                border: 1px solid #d1d5db;
                background: #f3f4f6;
                color: #6b7280;
                font-size: var(--text-s);
                cursor: pointer;
                transition: all 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;

                .btn-text {
                  color: #6b7280;
                  font-size: var(--text-s);
                  font-weight: 500;
                }

                &:hover {
                  border-color: #9ca3af;
                  background: #e5e7eb;
                }

                &.active {
                  border-color: #6b7280;
                  background-color: #f3f4f6;
                  color: #374151;

                  .btn-text {
                    color: #374151;
                  }
                }
              }
            }

            .delete-btn {
              background: none;
              border: none;
              cursor: pointer;
              opacity: 0;
              transition: opacity 0.2s;
              font-size: var(--text-l);

              &:hover {
                color: #ef4444;
              }

              &:disabled {
                opacity: 0.3;
                cursor: not-allowed;
              }
            }
          }
        }
      }
    }

    .summary-section {
      padding: 16px 24px;
      border-top: 1px solid #e5e7eb;
      background-color: #f9fafb;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      .summary-stats {
        display: flex;
        gap: 32px;
        font-size: var(--text-base);

        .stat-item {
          display: flex;
          gap: 8px;

          .stat-label {
            color: #6b7280;
          }

          .stat-value {
            color: #111827;
            font-weight: 500;

            &.passed {
              color: #065f46;
            }

            &.failed {
              color: #991b1b;
            }
          }
        }
      }
    }
  }

  .dialog-footer {
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
    background: white;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;

    .btn {
      padding: 8px 16px;
      border-radius: 4px;
      font-size: var(--text-base);
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
      display: flex;
      align-items: center;
      gap: 8px;

      &.btn-cancel {
        background-color: #f3f4f6;
        color: #374151;

        &:hover {
          background-color: #e5e7eb;
        }
      }

      &.btn-history {
        background-color: #3b82f6;
        color: white;

        &:hover {
          background-color: #2563eb;
        }

        .history-icon {
          margin-right: 4px;
        }
      }

      &.btn-save {
        background-color:  var(--brand-color);
        color: rgb(0, 0, 0);

        &:hover {
        }

        .save-icon {
          font-size: var(--text-l);
        }
      }
    }
  }
}
.no-hover:hover {
  background-color: inherit !important;
  cursor: default !important;
  transform: none !important;
}
.table, .qc-inspection-dialog{
  transition: all 0.3s ease-in-out;
}
.column-required-asterisk {
          font-size: 15px;
          font-weight: 700;
          color: #dc2626;
          line-height: 1;
          flex-shrink: 0;
          user-select: none;
          margin-left: 0;
        }
</style>
